import React from 'react'
import * as ReactDOMClient from 'react-dom/client';
import App from './components/app/App'

const container = document.getElementById('root');
const root = ReactDOMClient.createRoot(container);

;(function () {
    const htmlElement = document.querySelector("html")
    if(htmlElement.dataset.bsTheme === 'auto') {
        function updateTheme() {
            document.querySelector("html").dataset.bsTheme = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"
        }

        window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', updateTheme)
        updateTheme()
    }
})()

root.render(<App />)
